import { render } from "./fancy-text-block.vue?vue&type=template&id=128cffc6"
import script from "./fancy-text-block.vue?vue&type=script&lang=js"
export * from "./fancy-text-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__